import { Analytics } from '@1debit/analytics';
import { generateDeviceId } from '@1debit/device-intelligence';

import { IS_DEV_ENV, IS_PROD_ENV } from 'consts/appConsts';
import {
  getBrowserForTracking,
  getDeviceTypeForTracking,
} from 'consts/platformConsts';
import {
  Facebook_Click,
  Facebook_Pixel_Identifier,
  REFERRED_BY_ID,
  REFERRER_NAME,
} from 'consts/storageConsts';

import { deviceIntelligenceEnvironment } from 'utils/deviceIntelligenceUtils';
import {
  AD_CAMPAIGN_QSP,
  AD_ID_QSP,
  AF_ADVERTISING_ID_QSP,
  AF_ID_QSP,
  EMBEDDED_APP_VERSION,
  IS_EMBEDDED,
} from 'utils/queryParamHelpers';
import cookies from 'utils/storage/cookies';

const getEnv = () => {
  if (IS_PROD_ENV) return 'production';
  if (IS_DEV_ENV) return 'development';
  return 'qa';
};

export const analyticsHandler = new Analytics({
  variant: 'onlyEventRouter',
  env: getEnv(),
});

const EVENT_PRODUCER = 'CHIME_SERVICE_ENROLLMENT_CLIENT';

export function initializeEventRouter() {
  analyticsHandler.init({
    eventProducer: EVENT_PRODUCER,
    device: {
      name: getDeviceTypeForTracking() ?? null,
      id:
        generateDeviceId({
          env: deviceIntelligenceEnvironment,
        }) ?? null,
    },
    app: {
      version: EMBEDDED_APP_VERSION,
    },
    third_party_identifiers: {
      apps_flyer: {
        af_advertising_id: AF_ADVERTISING_ID_QSP ?? null,
        afid: AF_ID_QSP ?? null,
        ad_campaign_id: AD_CAMPAIGN_QSP ?? null,
      },
      meta: {
        fbc: cookies.get(Facebook_Click) ?? null,
        fbp: cookies.get(Facebook_Pixel_Identifier) ?? null,
      },
      paid: {
        ad_id: AD_ID_QSP ?? null,
        ad_campaign_id: AD_CAMPAIGN_QSP ?? null,
      },
    },
    browser: {
      is_embedded: IS_EMBEDDED ?? null,
      name: getBrowserForTracking() ?? null,
    },
    referral: {
      referred_by_id: cookies.get(REFERRED_BY_ID) ?? null,
      referred_by_name: cookies.get(REFERRER_NAME) ?? null,
    },
  });
}

export function identifyUser(options = {}) {
  const { userId, properties } = options;

  analyticsHandler.identify(userId, properties);
}
